import AccountInput from './AccountInput';
import Checkbox from './Checkbox';
import CheckboxCol from './Checkbox';
import Container from './Container';
import DataGrid from './DataGrid';
import ContainerRow from './ContainerRow';
import Date from './DatePicker';
import DateTime from './DateTimePicker';
import DropDown from './Dropdown';
import DropdownCol from './Dropdown';
import Form from './Form';
import Image from './Image';
import DomainImage from './DomainImage'
import PaymentMethod from './PaymentMethod';
import Radio from './Radio';
import RadioCol from './Radio';
import TextBox from './TextBox';
import TextInput from './TextInput';
import Number from './Number'
import NumberCol from './Number'
import PlainText from './PlainText'
import Button from './Button'
import Currency from './Currency'
import CurrencyCol from './Currency'
import Email from './Email'
import EmailCol from './Email'
import Switch from './Switch'
import SwitchCol from './Switch'
import PhoneNumber from './PhoneNumber'
import PhoneNumberCol from './PhoneNumber'
import HtmlLink from './HtmlLink'
import RepeatableContainer from './RepeatableContainer'
import RepeatableForm from './RepeatableForm'
import ViewRow from './ViewRow'
import ViewCol from './ViewCol'
import ViewFooter from './ViewFooter'
import ViewHeader from './ViewHeader'
import SplitColumn from './SplitColumn'
import TextInputCol from './TextInput'
import DateCol from './DatePicker'
import { BaseUIComponent } from './BaseUIComponent';

const UIComponents = {
  AccountInput,
  Checkbox,
  Container,
  DataGrid,
  ContainerRow,
  DateCol,
  CurrencyCol,
  NumberCol,
  RadioCol,
  DropdownCol,
  CheckboxCol,
  DateTime,
  EmailCol,
  SwitchCol,
  PhoneNumberCol,
  RepeatableContainer,
  RepeatableForm,
  Switch,
  Date,
  DropDown,
  Form,
  Image,
  TextInputCol,
  DomainImage,
  PaymentMethod,
  Radio,
  TextBox,
  TextInput,
  Number,
  PlainText,
  Button,
  Currency,
  PhoneNumber,
  Email,
  HtmlLink,
  ViewCol,
  ViewRow,
  ViewFooter,
  ViewHeader,
  SplitColumn
}

const MetadataComponents = {} as {[key:string]:typeof BaseUIComponent}

for(let x in UIComponents){
    // @ts-ignore
    MetadataComponents[x] = UIComponents[x];
}

/**
 * get the React class that is used to render the ui component.
 * 
 * @param uiComponentType type of IUIComponentDef.
 */
export function getReactClass(uiComponentType:string){
    const reactClass = MetadataComponents[uiComponentType];
    return reactClass;
}